export default "__VITE_ASSET__CG4u0VZm__"